const TableCellTag = (props: any) => {
  let color = props.color ?? "rgb(95, 181, 235)";
  let label = props.label ?? "";
  return (
    <td>
      <span style={{ background: color }} className="Tag">{label}</span>
    </td>
  )
}

export default TableCellTag